export const InfoIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        d="M7.96827 5.32615C7.78139 5.32615 7.62326 5.26146 7.49387 5.13208C7.36449 5.0027 7.2998 4.84457 7.2998 4.65768C7.2998 4.4708 7.36449 4.31626 7.49387 4.19407C7.62326 4.06469 7.78139 4 7.96827 4C8.15515 4 8.30969 4.06469 8.43188 4.19407C8.56126 4.31626 8.62595 4.4708 8.62595 4.65768C8.62595 4.84457 8.56126 5.0027 8.43188 5.13208C8.30969 5.26146 8.15515 5.32615 7.96827 5.32615ZM8.41032 12H7.51544V6.28572H8.41032V12Z"
        fill="#609399"
      />
      <circle cx="8" cy="8" r="7.5" stroke="#609399" />
    </svg>
  );
};

export const BlueInfoIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11 11V17H13V11H11ZM11 7V9H13V7H11Z"
        fill="#03292E"
      />
    </svg>
  );
};
